export const userShortName = (userInfo) => {
  return `${(userInfo.firstname || '').charAt(0)}${(userInfo.surname || '').charAt(0)}`;
};
export const deleteCookie = (cname, path, domain) => {
  if (getCookie(cname)) {
    document.cookie =
      cname + '=' + (path ? ';path=' + path : '') + (domain ? ';domain=' + domain : '') + ';expires=Thu, 01 Jan 1970 00:00:01 GMT';
  }
};
export const getCookie = (cname) => {
  var c, ca, decodedCookie, i, name;
  name = cname + '=';
  decodedCookie = decodeURIComponent(document.cookie);
  ca = decodedCookie.split(';');
  i = 0;
  while (i < ca.length) {
    c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
    i++;
  }
  return '';
};

export default {
  getCookie,
  userShortName,
};
